import AppStandardButton from "../../components/UI/AppButtons";
import { BookingInformationRow } from "../../components/Layouts/BookingInformation/BookingInformation";
import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { useLocation, useSearchParams } from "react-router-dom";
import { BookingApi } from "../../API/Apis/BookingApi";
import { NexiChargeTransactionDetails } from "../../@types/Booking/nexiTransactionDetails";
import TagManager from "react-gtm-module";
import BookingGetters from "../../store/onlineBooking/getters";
import { Vehicle } from "../../@types/DTO/Vehicles";
import { SelectedVehicleDetails } from "../../@types/Booking/SelectedVehicleDetails";
import { TextResource } from "../../@types/DTO/AppSetting";
import { formatTheme } from "../../config/MuiColorThemes";
import { createTheme } from "@mui/material/styles";
import i18n from "../../config/i18n";
import { useTranslation } from "react-i18next";
import { BookingDetails } from "../../@types/Booking/bookingDetails";
export function WireTransferConfirm() {
  const isUserLoggedin = localStorage.getItem("isUserLoggedin");
  const appSettings = BookingGetters.getAppSettings();
  const redirectWebCheckIn = appSettings && appSettings?.redirectWebCheckIn;
  const HideOneButton =
    appSettings && appSettings?.hideButtonAtConfirmationPage;
  const hideHomeButtonFromNormalBooking =
    appSettings && appSettings?.hideHomeButtonFromNormalBooking;
  const hideHomeButtonFromReservedArea =
    appSettings && appSettings?.hideHomeButtonFromReservedArea;
  const showHomeButton =
    (isUserLoggedin !== "true" && !hideHomeButtonFromNormalBooking) ||
    (isUserLoggedin === "true" && !hideHomeButtonFromReservedArea);
  const showResPrintButton = appSettings && appSettings?.showResPrintButton;
  const paymentDetails = BookingGetters.getSelectedVehicleDetails();
  const price = paymentDetails.paymentDetails.price;
  const [searchParams] = useSearchParams();
  const dbId = searchParams.get("dbId");
  const ResId = searchParams.get("ResId");

  const [showGtagManagerEvent, setGtagManagerEvent] = useState(
    appSettings?.gtagManagerEvent || ""
  );
  const [showGTagManagerSendTo, setGTagManagerSendTo] = useState(
    appSettings?.gTagManagerSendTo || ""
  );
  const [showGTagManagerCurrency, setGTagManagerCurrency] = useState(
    appSettings?.gTagManagerCurrency || ""
  );
  const [isTagManagerDataLayerEnabled, setIsTagManagerDataLayerEnabled] =
    useState(false);
  const [showGtagManagerValue, setGtagManagerValue] = useState(false);
  const [showGTagManagerTransactionId, setGTagManagerTransactionId] =
    useState(false);
  const [tagManagerId, setTagManagerId] = useState("");
  const [isTagManagerEnabled, setIsTagManagerEnabled] = useState(false);
  const showPrice = showGtagManagerValue ? price : null;
  const showDbId = showGTagManagerTransactionId ? dbId : null;
  const lang = i18n.language;
  const { t: translate } = useTranslation();
  const textResource = BookingGetters.getTextResourceDetailsBasedOnLang();
  const data = textResource?.[lang]?.flatMap((item) => item.data || []) || [];

  const [congratsText, setCongratsText] = useState({
    title: "",
    message: "",
    note: "",
  });
  const [showDiscoverThankText, setShowDiscoverThankText] =
    useState<String>("");
  const [discoverButtonText, setDiscoverButtonText] = useState<String>("");
  useEffect(() => {
    const titleText = data.find(
      (item) => item.key === "booking_congrats_title"
    );
    const messageText = data.find(
      (item) => item.key === "booking_congrats_message"
    );
    const noteText = data.find((item) => item.key === "booking_congrats_note");
    setCongratsText({
      title: titleText?.body || t("booking_congrats_title"),
      message: messageText?.body || t("booking_congrats_message"),
      note: noteText?.body || t("booking_congrats_note"),
    });

    const discoverThankTextData = data.find(
      (item) => item.key === "showDiscoverExpThankYou"
    );
    setShowDiscoverThankText(discoverThankTextData?.body || "");

    const discoverButtonTextData = data.find(
      (item) => item.key === "discoverButtonText"
    );
    setDiscoverButtonText(
      discoverButtonTextData?.body || t("Discover the experiences")
    );
  }, [textResource, lang, translate]);

  const dynamicPalette = formatTheme();
  const dynamicTheme = createTheme(dynamicPalette);
  const primaryColor = dynamicTheme?.palette["primary"]?.main;
  const secondaryColor = dynamicTheme?.palette["secondaryColor"]?.main;
  const confirmationTextColor =
    dynamicTheme?.palette["confirmationTextColor"]?.contrastText;
  const bookingInformation: BookingDetails = BookingGetters.getBookingDetails();
  const scriptChannel = bookingInformation?.scriptChannel;
  const scriptChannelWindow = window.name;
  const scriptChannelSession = sessionStorage.getItem("scriptChannel");
  useEffect(() => {
    setIsTagManagerDataLayerEnabled(!!appSettings?.enableDataLayer);
    setGTagManagerCurrency(appSettings?.gTagManagerCurrency || "");
    setGTagManagerSendTo(appSettings?.gTagManagerSendTo || "");
    setGtagManagerEvent(appSettings?.gtagManagerEvent || "");
    setGtagManagerValue(!!appSettings?.enableGtagManagerValue);
    setGTagManagerTransactionId(!!appSettings?.enableGTagManagerTranscationId);
    setIsTagManagerEnabled(!!appSettings?.enableTagManager);
    setTagManagerId(appSettings?.tagManagerId || "");
  }, [appSettings]);
  useEffect(() => {
    if (process.env.REACT_APP_COMPANY_CODE === "viaggiare") {
      const checkOutDate = searchParams.get("DropOffUpDateTime") || "";
      let formattedDate;
      if (checkOutDate) {
        const date = new Date(checkOutDate);
        formattedDate =
          date.getFullYear() +
          "-" +
          String(date.getMonth() + 1).padStart(2, "0") +
          "-" +
          String(date.getDate()).padStart(2, "0");
      }

      const tempResId = searchParams.get("dbId");
      const currencyCode = appSettings?.defaultCurrency || "EUR";
      const script1 = document.createElement("script");
      script1.type = "text/javascript";
      script1.innerHTML = `
      var orderRef = ${JSON.stringify(
        tempResId + " " + searchParams.get("vehicleName") || ""
      )};
      var payoutCodes = '';
      var offlineCode = '';
      var uid = ${JSON.stringify(searchParams.get("vehicleCategory") || "")};
      var htname = '';
      var merchantID = 4918;
      var pixel = 0;
      var orderValue = ${parseFloat(searchParams.get("importo") || "0")};
      var checkOutDate = ${JSON.stringify(formattedDate || "")};
      var currencyCode = '${currencyCode}';
    `;

      const script2 = document.createElement("script");
      script2.type = "text/javascript";
      script2.src =
        "https://scripts.affilired.com/v2/confirmation.php?merid=4918";

      script2.onload = () => {
        const script3 = document.createElement("script");
        script3.type = "text/javascript";
        script3.innerHTML = `
        recV3(orderValue, orderRef, merchantID, uid, htname, pixel, payoutCodes, offlineCode, checkOutDate, currencyCode);
      `;
        document.body.appendChild(script3);
      };

      document.body.appendChild(script1);
      document.body.appendChild(script2);

      return () => {
        [script1, script2].forEach((script) => {
          if (document.body.contains(script)) document.body.removeChild(script);
        });
      };
    }
  }, []);
  function requestParentResize() {
    window.parent.postMessage(
      {
        event_id: "iframeHeight",
        data: {
          iframeHeight: 700,
        },
      },
      "*"
    );
  }
  useEffect(() => {
    requestParentResize();
  }, []);
  useEffect(() => {
    if (isTagManagerDataLayerEnabled) {
      const tagManagerArgs = {
        dataLayer: {
          event: showGtagManagerEvent,
          send_to: showGTagManagerSendTo,
          value: showPrice,
          currency: showGTagManagerCurrency,
          transaction_id: showDbId,
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  }, [isTagManagerDataLayerEnabled]);
  useEffect(() => {
    if (isTagManagerEnabled && tagManagerId != "") {
      const tagManagerArgs = {
        gtmId: tagManagerId,
      };
      TagManager.initialize(tagManagerArgs); // google tag manager integrated along with the preferences
    }
  }, [tagManagerId, isTagManagerEnabled]);

  const secondPageBackgroundColor =
    appSettings && appSettings["secondPageBackgroundColor"];

  const isAffiliateEnable = appSettings && appSettings?.enableAffiliate;
  // const scriptAffiliate = bookingInformation?.affiliateDetails?.code;
  const scriptAffiliateSession = sessionStorage.getItem("scriptAffiliate");

  const isVoucherCodeEnable = appSettings && appSettings?.showWebCodeInput;
  const scriptVoucherCodeSession = sessionStorage.getItem("scriptVoucherCode");

  return (
    <section
      className="min-h-[100vh] box-border px-10 md:px-44  flex flex-col border-t-2 border-solid border-grey-300"
      style={{
        background: secondPageBackgroundColor ? secondPageBackgroundColor : "",
      }}
    >
      <header
        className={`grow flex flex-col items-center justify-center gap-4 box-border py-8 ${
          !appSettings?.showDiscoverExpThankYou ? "mt-10" : ""
        }`}
      >
        <img src="/assets/images/success-icon@2x.png" className="h-36 w-36" />
        <h1
          className="text-3xl font-bold py-2 text-center"
          style={{
            color: confirmationTextColor
              ? confirmationTextColor
              : secondaryColor,
          }}
        >
          <p>{congratsText?.title}</p>
          <p>{congratsText?.message}</p>
          <p>{congratsText?.note}</p>
        </h1>
        <p className="font-bold text-black-600"></p>
        <div className="flex flex-col-2 ">
          {" "}
          {showHomeButton && (
            <>
              <AppStandardButton
                // href={
                //   scriptChannelWindow || scriptChannel
                //     ? `/embed?scriptChannel=${
                //         scriptChannelSession ||
                //         scriptChannelWindow ||
                //         scriptChannel
                //       }`
                //     : "/embed"
                // }
                // href={
                //   scriptChannelWindow || scriptChannel
                //     ? `/embed?scriptChannel=${
                //         scriptChannelSession ||
                //         scriptChannelWindow ||
                //         scriptChannel
                //       }`
                //     : isAffiliateEnable &&
                //       (scriptAffiliate || scriptAffiliateSession)
                //     ? `/embed?scriptAffiliate=${
                //         scriptAffiliateSession || scriptAffiliate
                //       }`
                //     : "/embed"
                // }
                href={
                  scriptChannelWindow || scriptChannel
                    ? `/embed?scriptChannel=${
                        scriptChannelSession ||
                        scriptChannelWindow ||
                        scriptChannel
                      }`
                    : isAffiliateEnable && scriptAffiliateSession
                    ? `/embed?scriptAffiliate=${scriptAffiliateSession}`
                    : isVoucherCodeEnable && scriptVoucherCodeSession
                    ? `/embed?scriptVoucherCode=${scriptVoucherCodeSession}`
                    : "/embed"
                }
                className={"w-fit py-4 mx-0 md:mx-8"}
                variant="outlined"
                /* color="secondaryColor"*/
                style={{
                  borderRadius: "5",
                  borderColor: confirmationTextColor
                    ? confirmationTextColor
                    : primaryColor,
                }}
              >
                {/* Go to Account */}
                <span
                  className="normal-case p-1 text-lg"
                  style={{
                    color: confirmationTextColor
                      ? confirmationTextColor
                      : secondaryColor,
                  }}
                >
                  {" "}
                  Homepage
                </span>
              </AppStandardButton>
            </>
          )}
          {!redirectWebCheckIn
            ? !HideOneButton && (
                <AppStandardButton
                  // href={
                  //   scriptChannelWindow || scriptChannel
                  //     ? `/embed?scriptChannel=${
                  //         scriptChannelSession ||
                  //         scriptChannelWindow ||
                  //         scriptChannel
                  //       }`
                  //     : "/embed"
                  // }
                  // href={
                  //   scriptChannelWindow || scriptChannel
                  //     ? `/embed?scriptChannel=${
                  //         scriptChannelSession ||
                  //         scriptChannelWindow ||
                  //         scriptChannel
                  //       }`
                  //     : isAffiliateEnable &&
                  //       (scriptAffiliate || scriptAffiliateSession)
                  //     ? `/embed?scriptAffiliate=${
                  //         scriptAffiliateSession || scriptAffiliate
                  //       }`
                  //     : "/embed"
                  // }
                  href={
                    scriptChannelWindow || scriptChannel
                      ? `/embed?scriptChannel=${
                          scriptChannelSession ||
                          scriptChannelWindow ||
                          scriptChannel
                        }`
                      : isAffiliateEnable && scriptAffiliateSession
                      ? `/embed?scriptAffiliate=${scriptAffiliateSession}`
                      : isVoucherCodeEnable && scriptVoucherCodeSession
                      ? `/embed?scriptVoucherCode=${scriptVoucherCodeSession}`
                      : "/embed"
                  }
                  className={"w-fit py-4 mx-2 md:mx-8"}
                  /*  color="secondaryColor"*/
                  variant="outlined"
                  style={{
                    borderRadius: "5",
                    borderColor: confirmationTextColor
                      ? confirmationTextColor
                      : primaryColor,
                  }}
                >
                  {/*  Go to Account*/}
                  <span
                    className="normal-case p-1 text-lg"
                    style={{
                      color: confirmationTextColor
                        ? confirmationTextColor
                        : secondaryColor,
                    }}
                  >
                    {" "}
                    Dashboard
                  </span>
                </AppStandardButton>
              )
            : isUserLoggedin == "true" &&
              appSettings?.showWebCheckReservArea &&
              !HideOneButton && (
                <AppStandardButton
                  href={`/booking/web-check-in?lang=${i18n.language}`}
                  className={"w-fit py-4 mx-2 md:mx-8"}
                  /*  color="primary"*/
                  variant="outlined"
                  style={{
                    borderRadius: "5",
                    borderColor: confirmationTextColor
                      ? confirmationTextColor
                      : primaryColor,
                  }}
                >
                  <span
                    className="normal-case p-1 text-lg whitespace-nowrap"
                    style={{
                      color: confirmationTextColor
                        ? confirmationTextColor
                        : secondaryColor,
                    }}
                  >
                    {" "}
                    Web Check-In
                  </span>
                </AppStandardButton>
              )}
          {showResPrintButton && (
            <AppStandardButton
              onClick={() => {
                BookingApi.getResPrint(ResId || "", lang).then((e) => {
                  const url = e?.file;
                  const linkSource = `data:application/pdf;base64,${url}`;
                  const downloadLink = document.createElement("a");
                  const fileName = "file.pdf";
                  downloadLink.href = linkSource;
                  downloadLink.download = fileName;
                  downloadLink.click();
                });
              }}
              className={"w-fit py-4 mx-2 md:mx-8"}
              variant="outlined"
              style={{ borderRadius: "5", color: primaryColor }}
            >
              <span
                className="normal-case p-1 text-lg whitespace-nowrap"
                style={{ color: secondaryColor }}
              >
                {" "}
                Print Reservation
              </span>
            </AppStandardButton>
          )}
        </div>
      </header>
      <main className="flex flex-col items-center justify-center gap-4 box-border py-8">
        {appSettings?.showDiscoverExpThankYou && (
          <>
            <p
              className="text-xl font-semibold py-2"
              style={{
                color: confirmationTextColor
                  ? confirmationTextColor
                  : secondaryColor,
              }}
            >
              {showDiscoverThankText}
            </p>
            <AppStandardButton
              href="https://brevetermine.viaggiarerent.com/promo/civitatis/"
              className={"w-fit py-4 mx-5 md:mx-8"}
              variant="outlined"
              style={{
                borderRadius: "5",
                borderColor: confirmationTextColor
                  ? confirmationTextColor
                  : primaryColor,
              }}
            >
              <span
                className="normal-case p-1 text-sm"
                style={{
                  color: confirmationTextColor
                    ? confirmationTextColor
                    : secondaryColor,
                }}
              >
                {discoverButtonText}
              </span>
            </AppStandardButton>
          </>
        )}
      </main>
      <footer className="text-gray-600 box-border pb-32">
        {/* Web Checkin Info */}
        {/* Web Checkin Information */}

        <div className="box-border border-2 border-solid border-grey-200 px-8"></div>
      </footer>
    </section>
  );
}
